<script setup lang="ts">
  import { OrganizationPreview } from '@borg/types';
  import { MpButton } from '@borg/ui';

  const props = defineProps<{
    id: OrganizationPreview['id'];
  }>();

  const { t } = useI18n();
  const { data: organizationFollowStatus } = await organizationFollowRepository.getFollowStatus(
    props.id,
  );

  const isLoading = ref(false);

  const isFollowing = computed(() => !!organizationFollowStatus.value?.follow);
  const icon = computed(() => (isFollowing.value ? 'check_mark' : 'add'));
  const text = computed(() =>
    isFollowing.value ? t('ORGANIZATION_FOLLOW.FOLLOWING') : t('ORGANIZATION_FOLLOW.NOT_FOLLOWING'),
  );

  async function toggleFollow() {
    try {
      organizationFollowStatus.value = { follow: !isFollowing.value };
      await organizationFollowRepository.toggleFollowStatus(props.id, isFollowing.value);
    } catch (e) {
      organizationFollowStatus.value = { follow: !isFollowing.value };
    }
  }
</script>

<template>
  <MpButton
    :is-loading="isLoading"
    :disabled="isLoading"
    :left-icon="icon"
    :text="text"
    variant="plain"
    @click="toggleFollow"
  />
</template>

<style scoped lang="scss"></style>
